import { P2GBox, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import { Navigation } from '~/components/nav/nav';
import { NavExperienceProvider } from '~/components/nav/nav-experience';
import Notifications from '~/apps/smartsend/components/notifications/Notifications';
import Edit from '~/apps/smartsend/components/smartsend/edit/Edit';
import SupportBackgroundTasks from '~/apps/smartsend/components/smartsend/background/SupportBackgroundTasks';

// The consumer "My Account" experience shell. Mirrors SmartSendLayout (grey background +
// <Navigation>), but renders the consumer sidebar (chosen by experience) and omits the
// SmartSend-only marketing chrome (tasks, walkthrough, smartsend tasks, banners). Per-page
// titles + tabs come from the account-area layouts below the Outlet; the functional order
// Edit drawer and toast Notifications are kept.
export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  return (
    <NavExperienceProvider experience="consumer">
      <SupportBackgroundTasks />
      <P2GBox sx={(t) => ({ backgroundColor: t.palette.grey?.A100 })}>
        <Navigation isXs={isXs}>
          <Outlet />
        </Navigation>
      </P2GBox>
      <Notifications />
      <Edit />
    </NavExperienceProvider>
  );
}

Component.displayName = 'My Account (Consumer)';
